import React from 'react';

import { Flex } from '../../../Flex';
import { TableColumnSettingsButton } from '../TableColumnSettings';
import { TableFilterResetButton } from '../TableFilterResetButton';

export const TableToolbarActions: React.FC = () => (
    <Flex align="center" gap={2}>
        <TableFilterResetButton />
        <TableColumnSettingsButton />
    </Flex>
);
